import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import {
  attributeAvailibilityReasonEnum,
  IAttributeValueAvailibility,
} from 'src/app/models/interfaces/GenericInterfaces';
import { NumericChange } from 'src/app/models/product-models/views/Attribute';
import { LocalizedText } from 'src/app/models/product-models/views/LocalizedText';
import { Product } from 'src/app/models/product-models/views/Product';

@Component({
  selector: 'app-numeric-attribute-select',
  templateUrl: './numeric-attribute-select.component.html',
  styleUrls: ['./numeric-attribute-select.component.scss'],
})
export class NumericAttributeSelectComponent implements OnInit {
  @Input() attribute?: NumericChange;
  @Input() currentValue?: number;

  @Input() showConfirmButton = false;
  @Input() showLabel = true;

  @Output() valueChanged: EventEmitter<number> = new EventEmitter<number>();

  @Input() product?: Product;

  public possibleValues: number[] = [];

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.attribute) this.possibleValues = this._calculatePossibleValues(this.attribute);
  }

  public isInputChanged = new BehaviorSubject(false);

  constructor(private translateService: TranslateService) {}

  public get unit() {
    if (this.attribute instanceof NumericChange) return this.attribute?.unit ? this.attribute?.unit : 'm';
    return 'm';
  }

  public get unitFactor() {
    if (this.attribute instanceof NumericChange) return this.attribute?.unitFactor ? this.attribute?.unitFactor : 1;
    return 1;
  }

  public get numericAttribute() {
    return this.attribute as NumericChange;
  }

  public get current() {
    const foundValue = this.possibleValues.find((value) => value === this.currentValue);

    if (foundValue) return foundValue;
    return 0;
  }

  public set current(val: number) {
    this.currentValue = val;
  }

  onInputChange(change: MatSelectChange) {
    if (typeof change.value === 'number') {
      this.valueChanged.emit(change.value);
      this.current = change.value;
    }
  }

  onInput() {
    if (this.showConfirmButton) {
      this.isInputChanged.next(true);
    }
  }

  public parseReason(availibility: IAttributeValueAvailibility) {
    if (!availibility.isAvailible && availibility.reason) {
      return this.translateService.instant('translations.' + availibility.reason);
    }
    return '';
  }

  public checkIfValueCanBeSet(value: number): IAttributeValueAvailibility {
    if (this.attribute && this.product) return this.product.checkIfAttributeCanBeSet(this.attribute, value);

    return { isAvailible: false, reason: attributeAvailibilityReasonEnum.internalError };
  }

  private _calculatePossibleValues(attribute: NumericChange) {
    const possibleValues: number[] = [];
    for (let value = attribute.min; value <= attribute.max; value = parseFloat((value + attribute.step).toFixed(2))) {
      possibleValues.push(value);
    }
    return possibleValues;
  }

  public confirmInput() {
    //this.selectUnitConversionDirective?.checkValidity();
    if (this.currentValue === undefined) return;
    const value = this.currentValue;
    this.valueChanged.emit(value);
    this.isInputChanged.next(false);
  }

  getLocalizedString(texts: LocalizedText[]): string | null {
    if (!texts) return null;
    if (typeof texts === 'string') return texts;

    const text = texts.find((text) => text.language === this.translateService.currentLang);
    return text ? text.text : null;
  }
}
